import {
  CampaignReview,
  ICampaign,
  CampaignAnalytics,
  CampaignFilters,
  CampaignPagination,
  CampaignContactCounts,
} from '../../types/campaigns/campaigns.types';

// Action Types
export const GET_CAMPAIGNS_REQUEST = 'GET_CAMPAIGNS_REQUEST';
export const GET_CAMPAIGNS_SUCCESS = 'GET_CAMPAIGNS_SUCCESS';
export const GET_CAMPAIGNS_FAILURE = 'GET_CAMPAIGNS_FAILURE';

export const GET_CAMPAIGN_REQUEST = 'GET_CAMPAIGN_REQUEST';
export const GET_CAMPAIGN_SUCCESS = 'GET_CAMPAIGN_SUCCESS';
export const GET_CAMPAIGN_FAILURE = 'GET_CAMPAIGN_FAILURE';

export const CREATE_CAMPAIGN_REQUEST = 'CREATE_CAMPAIGN_REQUEST';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';
export const CREATE_CAMPAIGN_FAILURE = 'CREATE_CAMPAIGN_FAILURE';

export const UPDATE_CAMPAIGN_REQUEST = 'UPDATE_CAMPAIGN_REQUEST';
export const UPDATE_CAMPAIGN_SUCCESS = 'UPDATE_CAMPAIGN_SUCCESS';
export const UPDATE_CAMPAIGN_FAILURE = 'UPDATE_CAMPAIGN_FAILURE';

export const PUBLISH_CAMPAIGN_REQUEST = 'PUBLISH_CAMPAIGN_REQUEST';
export const PUBLISH_CAMPAIGN_SUCCESS = 'PUBLISH_CAMPAIGN_SUCCESS';
export const PUBLISH_CAMPAIGN_FAILURE = 'PUBLISH_CAMPAIGN_FAILURE';

export const CLEAR_CAMPAIGN_STATE = 'CLEAR_CAMPAIGN_STATE';
export const CLEAR_PUBLISH_CAMPAIGN_STATE = 'CLEAR_PUBLISH_CAMPAIGN_STATE';

export const REVIEW_CAMPAIGN_REQUEST = 'REVIEW_CAMPAIGN_REQUEST';
export const REVIEW_CAMPAIGN_SUCCESS = 'REVIEW_CAMPAIGN_SUCCESS';
export const REVIEW_CAMPAIGN_FAILURE = 'REVIEW_CAMPAIGN_FAILURE';

export const GET_CAMPAIGN_ANALYTICS_REQUEST = 'GET_CAMPAIGN_ANALYTICS_REQUEST';
export const GET_CAMPAIGN_ANALYTICS_SUCCESS = 'GET_CAMPAIGN_ANALYTICS_SUCCESS';
export const GET_CAMPAIGN_ANALYTICS_FAILURE = 'GET_CAMPAIGN_ANALYTICS_FAILURE';

export const DUPLICATE_CAMPAIGN_REQUEST = 'DUPLICATE_CAMPAIGN_REQUEST';
export const DUPLICATE_CAMPAIGN_SUCCESS = 'DUPLICATE_CAMPAIGN_SUCCESS';
export const DUPLICATE_CAMPAIGN_FAILURE = 'DUPLICATE_CAMPAIGN_FAILURE';

export const DELETE_CAMPAIGN_REQUEST = 'DELETE_CAMPAIGN_REQUEST';
export const DELETE_CAMPAIGN_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS';
export const DELETE_CAMPAIGN_FAILURE = 'DELETE_CAMPAIGN_FAILURE';
export const CLEAR_DELETE_STATE = 'CLEAR_DELETE_STATE';

export const PAUSE_CAMPAIGN_REQUEST = 'PAUSE_CAMPAIGN_REQUEST';
export const PAUSE_CAMPAIGN_SUCCESS = 'PAUSE_CAMPAIGN_SUCCESS';
export const PAUSE_CAMPAIGN_FAILURE = 'PAUSE_CAMPAIGN_FAILURE';

export const CLEAR_PAUSE_CAMPAIGN_STATE = 'CLEAR_PAUSE_CAMPAIGN_STATE';

export const GET_CAMPAIGN_CONTACT_COUNTS_REQUEST =
  'GET_CAMPAIGN_CONTACT_COUNTS_REQUEST';
export const GET_CAMPAIGN_CONTACT_COUNTS_SUCCESS =
  'GET_CAMPAIGN_CONTACT_COUNTS_SUCCESS';
export const GET_CAMPAIGN_CONTACT_COUNTS_FAILURE =
  'GET_CAMPAIGN_CONTACT_COUNTS_FAILURE';

// Action Interfaces
export interface GetCampaignsRequestAction {
  type: typeof GET_CAMPAIGNS_REQUEST;
  payload?: CampaignFilters;
}

export interface GetCampaignsSuccessAction {
  type: typeof GET_CAMPAIGNS_SUCCESS;
  payload: {
    campaigns: ICampaign[];
    pagination: CampaignPagination;
  };
  [key: string]: any;
}

export interface GetCampaignsFailureAction {
  type: typeof GET_CAMPAIGNS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface GetCampaignRequestAction {
  type: typeof GET_CAMPAIGN_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface GetCampaignSuccessAction {
  type: typeof GET_CAMPAIGN_SUCCESS;
  payload: ICampaign;
  [key: string]: any;
}

export interface GetCampaignFailureAction {
  type: typeof GET_CAMPAIGN_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface CreateCampaignRequestAction {
  type: typeof CREATE_CAMPAIGN_REQUEST;
  payload: { name: string };
  [key: string]: any;
}

export interface CreateCampaignSuccessAction {
  type: typeof CREATE_CAMPAIGN_SUCCESS;
  payload: ICampaign;
  [key: string]: any;
}

export interface CreateCampaignFailureAction {
  type: typeof CREATE_CAMPAIGN_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface UpdateCampaignRequestAction {
  type: typeof UPDATE_CAMPAIGN_REQUEST;
  payload: {
    campaignId: string;
    campaignData: {
      name?: string;
      description?: string;
      goal?: any;
      exitSurvey?: string;
    };
  };
  [key: string]: any;
}

export interface UpdateCampaignSuccessAction {
  type: typeof UPDATE_CAMPAIGN_SUCCESS;
  payload: ICampaign;
  [key: string]: any;
}

export interface UpdateCampaignFailureAction {
  type: typeof UPDATE_CAMPAIGN_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface PublishCampaignRequestAction {
  type: typeof PUBLISH_CAMPAIGN_REQUEST;
  payload: {
    campaignId: string;
    selectedType?: 'all_contacts' | 'future_contacts';
  };
  [key: string]: any;
}

export interface PublishCampaignSuccessAction {
  type: typeof PUBLISH_CAMPAIGN_SUCCESS;
  payload: ICampaign;
  [key: string]: any;
}

export interface PublishCampaignFailureAction {
  type: typeof PUBLISH_CAMPAIGN_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearCampaignStateAction {
  type: typeof CLEAR_CAMPAIGN_STATE;
  [key: string]: any;
}

export interface ClearPublishCampaignStateAction {
  type: typeof CLEAR_PUBLISH_CAMPAIGN_STATE;
  [key: string]: any;
}

export interface ReviewCampaignRequestAction {
  type: typeof REVIEW_CAMPAIGN_REQUEST;
  payload: { campaignId: string };
  [key: string]: any;
}

export interface ReviewCampaignSuccessAction {
  type: typeof REVIEW_CAMPAIGN_SUCCESS;
  payload: CampaignReview;
  [key: string]: any;
}

export interface ReviewCampaignFailureAction {
  type: typeof REVIEW_CAMPAIGN_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface GetCampaignAnalyticsRequestAction {
  type: typeof GET_CAMPAIGN_ANALYTICS_REQUEST;
  payload: { campaignId: string; startDate?: string; endDate?: string };
  [key: string]: any;
}

export interface GetCampaignAnalyticsSuccessAction {
  type: typeof GET_CAMPAIGN_ANALYTICS_SUCCESS;
  payload: CampaignAnalytics;
  [key: string]: any;
}

export interface GetCampaignAnalyticsFailureAction {
  type: typeof GET_CAMPAIGN_ANALYTICS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface DuplicateCampaignRequestAction {
  type: typeof DUPLICATE_CAMPAIGN_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface DuplicateCampaignSuccessAction {
  type: typeof DUPLICATE_CAMPAIGN_SUCCESS;
  payload: ICampaign;
  [key: string]: any;
}

export interface DuplicateCampaignFailureAction {
  type: typeof DUPLICATE_CAMPAIGN_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface DeleteCampaignRequestAction {
  type: typeof DELETE_CAMPAIGN_REQUEST;
  payload: { campaignId: string; filters?: CampaignFilters };
  [key: string]: any;
}

export interface DeleteCampaignSuccessAction {
  type: typeof DELETE_CAMPAIGN_SUCCESS;
  payload: { campaignId: string };
  [key: string]: any;
}

export interface DeleteCampaignFailureAction {
  type: typeof DELETE_CAMPAIGN_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearDeleteStateAction {
  type: typeof CLEAR_DELETE_STATE;
  [key: string]: any;
}

export interface PauseCampaignRequestAction {
  type: typeof PAUSE_CAMPAIGN_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface PauseCampaignSuccessAction {
  type: typeof PAUSE_CAMPAIGN_SUCCESS;
  payload: ICampaign;
  [key: string]: any;
}

export interface PauseCampaignFailureAction {
  type: typeof PAUSE_CAMPAIGN_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearPauseCampaignStateAction {
  type: typeof CLEAR_PAUSE_CAMPAIGN_STATE;
  [key: string]: any;
}
export interface GetCampaignContactCountsRequestAction {
  type: typeof GET_CAMPAIGN_CONTACT_COUNTS_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface GetCampaignContactCountsSuccessAction {
  type: typeof GET_CAMPAIGN_CONTACT_COUNTS_SUCCESS;
  payload: CampaignContactCounts;
  [key: string]: any;
}

export interface GetCampaignContactCountsFailureAction {
  type: typeof GET_CAMPAIGN_CONTACT_COUNTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export type CampaignActionTypes =
  | GetCampaignsRequestAction
  | GetCampaignsSuccessAction
  | GetCampaignsFailureAction
  | GetCampaignRequestAction
  | GetCampaignSuccessAction
  | GetCampaignFailureAction
  | CreateCampaignRequestAction
  | CreateCampaignSuccessAction
  | CreateCampaignFailureAction
  | UpdateCampaignRequestAction
  | UpdateCampaignSuccessAction
  | UpdateCampaignFailureAction
  | PublishCampaignRequestAction
  | PublishCampaignSuccessAction
  | PublishCampaignFailureAction
  | ClearCampaignStateAction
  | ClearPublishCampaignStateAction
  | ReviewCampaignRequestAction
  | ReviewCampaignSuccessAction
  | ReviewCampaignFailureAction
  | GetCampaignAnalyticsRequestAction
  | GetCampaignAnalyticsSuccessAction
  | GetCampaignAnalyticsFailureAction
  | DuplicateCampaignRequestAction
  | DuplicateCampaignSuccessAction
  | DuplicateCampaignFailureAction
  | DeleteCampaignRequestAction
  | DeleteCampaignSuccessAction
  | DeleteCampaignFailureAction
  | ClearDeleteStateAction
  | PauseCampaignRequestAction
  | PauseCampaignSuccessAction
  | PauseCampaignFailureAction
  | ClearPauseCampaignStateAction
  | GetCampaignContactCountsRequestAction
  | GetCampaignContactCountsSuccessAction
  | GetCampaignContactCountsFailureAction;
